(function () {
  var loading = {}

  function loadScript(name) {
    if (!name) return Promise.resolve()
    if (loading[name]) return loading[name]
    if (document.querySelector('[data-dpp-theme-script="' + name + '"]')) return Promise.resolve()

    var assetMap = window.DPPThemeAssets || {}
    var src = assetMap[name]
    if (!src) return Promise.resolve()

    loading[name] = new Promise(function (resolve, reject) {
      var script = document.createElement('script')
      script.src = src
      script.defer = true
      script.onload = function () { resolve() }
      script.onerror = function () { reject(new Error('load_failed:' + name)) }
      document.head.appendChild(script)
    })

    return loading[name]
  }

  function resolveTemplateName() {
    if (!document.body) return ''
    return document.body.getAttribute('data-template-name') || ''
  }

  function bootstrapThemeScripts() {
    var templateName = resolveTemplateName()

    if (templateName === 'product') {
      loadScript('product').catch(function () {})
      return
    }

    if (templateName === 'collection') {
      loadScript('collection').catch(function () {})
    }

    if (templateName === 'cart') {
      loadScript('cart').catch(function () {})
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapThemeScripts)
  } else {
    bootstrapThemeScripts()
  }
})()
